export default (theme) => ({
  totalCost: {
    minWidth: 130,
    fontWeight: "bold",
  },
  maxWidthCol: {
    maxWidth: 170,
    [theme.breakpoints.down("sm")]: {
      maxWidth: "inherit",
    },
  },
  duracao: {
    textTransform: "lowercase",
  },
  capitalize: {
    textTransform: "capitalize",
  },
});
